import { formatTime } from '@/filters/time.js'
import { getDateConfig } from '@/utils/dateConfig'

export default {
  methods: {
    getPeriod(configData) {
      const time = new Date().getTime() / 1000
      const time_format_1 = getDateConfig().year_mins
      const time_format_2 = getDateConfig().expires_at
      const {
        timeType,
        userCouponCreateTime,
        userCouponExpireTime,
        timeBegin,
        timeEnd,
      } = configData
      // timeType	1、固定天数 2、固定日期
      // 当优惠券当前时间在有效期内时展示“xx年xx月xx日xx时:xx分前支持使用”；
      // 如果当前时间在有效期之前时，展示“xx年xx月xx日xx时:xx分后支持使用”
      if (timeType === 1) {
        // userCouponCreateTime	优惠券有效时间
        // userCouponExpireTime	优惠券作废时间
        // 如果当前时间小于开始时间, 则不在有效期内
        return time < Number(userCouponCreateTime)
          ? `${formatTime(userCouponCreateTime, time_format_1)}-${formatTime(
              userCouponExpireTime,
              time_format_1
            )}`
          : `${formatTime(userCouponExpireTime, time_format_2)}`
      }
      // timeBegin	优惠券起始时间
      // timeEnd	优惠券结束时间
      return time < Number(timeBegin)
        ? `${formatTime(timeBegin, time_format_1)}-${formatTime(
            timeEnd,
            time_format_1
          )}`
        : `${formatTime(timeEnd, time_format_2)}`
    },
  },
}
